import React from "react";

const About = () => {
  return (
    <section className="relative py-24 px-6 md:px-20 bg-black overflow-hidden">
      <div className="md:flex md:gap-16 items-center">
        {/* Text Content */}
        <div className="md:w-1/2 mb-12 md:mb-0 relative z-10">
          <h2 className="text-3xl md:text-4xl font-bold mb-6 text-white animate-fadeIn">
            About
          </h2>
          <p className="text-lg md:text-xl text-white mb-4 animate-fadeIn delay-200">
            A curious and purpose-driven professional advocating for a just and socially equitable transition.
            Inspired by Guido d’Arezzo - who standardised and democratised music to make it accessible to all - I’m motivated by ideas that simplify complexity and enable inclusive, system-wide progress.
            Passionate about bridging profit and planet, I focus on responsible stewardship that strengthens resilience, builds trust, and unlocks sustainable commercial value.
            If you’re shaping a future that’s both ambitious and accountable, let’s connect.
          </p>
        </div>

        {/* Image Content */}
        <div className="md:w-1/2 relative group">
          <div className="overflow-hidden rounded-xl shadow-2xl transform transition-all duration-500 group-hover:scale-105">
            <img
              src="/images/Kenzo.jpeg"
              alt="Kenneth Milanzi "
              className="w-full h-full object-contain"
            />
          </div>

          {/* Subtle overlay */}
          <div className="absolute inset-0 rounded-xl bg-gradient-to-t from-black/40 to-transparent pointer-events-none"></div>
        </div>
      </div>

      {/* Optional subtle background accents (keep monochrome) */}
      <div className="absolute -top-24 -left-24 w-64 h-64 bg-white opacity-5 rounded-full blur-3xl pointer-events-none"></div>
      <div className="absolute -bottom-24 -right-24 w-72 h-72 bg-white opacity-5 rounded-full blur-3xl pointer-events-none"></div>
    </section>
  );
};

export default About;